import { camelizeKeys } from "humps";

import { BRAND_BUCKET, ORDERS_URL } from "api_urls";
import { getPrettyUrl } from "get_base_uri";

import {
  checkStatus,
  cloudfrontGetRequest,
  parseJSON,
  postRequest,
} from "helpers/ajax_request";
import { transformSettingsApiResponse } from "helpers/transforms/digital_gift_cards";

import type {
  DigitalGiftCardOrderApiResponse,
  DigitalGiftCardsOrderApiRequest,
  DigitalGiftCardsSettings,
} from "types/digital_gift_cards";

export function getDigitalGiftCardsSettings(): Promise<DigitalGiftCardsSettings> {
  return fetch(
    `${BRAND_BUCKET}/${getPrettyUrl()}/digital_gift_card.json`,
    cloudfrontGetRequest() as RequestInit
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys)
    .then(transformSettingsApiResponse);
}

export function postCreditCardPayment(
  orderInfo: DigitalGiftCardsOrderApiRequest
): Promise<DigitalGiftCardOrderApiResponse> {
  return fetch(
    `${ORDERS_URL}/gift_cards/issue`,
    postRequest(orderInfo) as RequestInit
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys);
}
